/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppontmentDto } from '../../models/appontment-dto';

export interface AppointmentGetallprovidersandresources$Params {
  emrpracticeId?: string | null;
  providerId?: string | null;
  apptType?: string | null;
  resourceId?: string | null;
}

export function appointmentGetallprovidersandresources(http: HttpClient, rootUrl: string, params?: AppointmentGetallprovidersandresources$Params, context?: HttpContext): Observable<StrictHttpResponse<AppontmentDto>> {
  const rb = new RequestBuilder(rootUrl, appointmentGetallprovidersandresources.PATH, 'get');
  if (params) {
    rb.query('emrpracticeId', params.emrpracticeId, {});
    rb.query('providerId', params.providerId, {});
    rb.query('apptType', params.apptType, {});
    rb.query('resourceId', params.resourceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AppontmentDto>;
    })
  );
}

appointmentGetallprovidersandresources.PATH = '/providers/getallprovidersandresources';
